import { Spacer, Text } from '@sparemin/blockhead';
import React, { useState } from 'react';
import Button from 'components/Button';

import RadioOptions, { Option } from 'components/RadioOptions';
import { popoverRadioGroupBlock as block } from './utils';

export type RadioGroupOptionItem<TValue> = {
  id: string;
  label: string;
  options: Option<TValue>[];
  value?: TValue;
  onChange?: (value: TValue) => void;
};

export type RadioGroupValue<TValue> = Record<string, TValue>;

export interface RadioGroupProps<TValue> {
  options: RadioGroupOptionItem<TValue>[];
  ctaLabel: string;
  defaultValue: RadioGroupValue<TValue>;
  onAction: (selectedValue: RadioGroupValue<TValue>) => void;
}

function RadioGroup<TValue>({
  options,
  ctaLabel,
  defaultValue,
  onAction,
}: RadioGroupProps<TValue>) {
  const [selectedValue, setSelectedValue] = useState<RadioGroupValue<TValue>>(
    defaultValue,
  );

  return (
    <Spacer space="20px" orientation="vertical" align="center">
      {options.map(option => (
        <RadioOptions
          key={option.id}
          appearance="checkmark"
          options={option.options}
          value={selectedValue[option.id]}
          listClassName={block('options-list')}
          optionClassName={block('option-item')}
          label={
            <Text variant="label" className={block('option-list-title')}>
              {option.label}
            </Text>
          }
          onChange={value =>
            setSelectedValue({ ...selectedValue, [option.id]: value })
          }
        />
      ))}

      <Button fluid theme="submit" onClick={() => onAction?.(selectedValue)}>
        {ctaLabel}
      </Button>
    </Spacer>
  );
}

export default RadioGroup;
